import { useQuery } from 'react-query'
import { getBusinessRules } from 'services/apiBusinessRule'
export function useGetBusinessRules(filters) {
  return useQuery(['businessRules', filters], () => getBusinessRules(filters), {
    refetchOnWindowFocus: false
  })
}
